import { Container } from 'pixi.js'

export default class makeContainer extends Container{
  constructor() {
    super()
  }
}
